import { Button, Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
const App: React.FC = () => {
    const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title={t('error.titleNotFound')}
      subTitle={t('error.NotFound')}
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/');
          }}
        >
          {t('error.backHome')}
        </Button>
      }
    />
  );
};

export default App;
